export default {"src":"/_next/static/media/scale.9b904970.svg","height":75,"width":76};